var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0228 6.86244C17.4278 6.75252 16.8813 7.13226 16.768 7.71311C16.6547 8.29396 17.0356 8.86107 17.6145 8.97474C19.3573 9.31451 20.703 10.6636 21.0441 12.4124V12.4136C21.1412 12.917 21.5844 13.283 22.0948 13.283C22.1633 13.283 22.2318 13.2768 22.3015 13.2643C22.8803 13.1481 23.2613 12.5823 23.148 12.0002C22.6388 9.38821 20.6284 7.37084 18.0228 6.86244Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9458 2.50991C17.6669 2.46994 17.3868 2.55238 17.164 2.72976C16.9349 2.90964 16.7918 3.16946 16.7607 3.46051C16.6947 4.04886 17.1192 4.58099 17.7068 4.64719C21.7588 5.09938 24.9084 8.25597 25.364 12.3207C25.425 12.8653 25.8819 13.2763 26.4271 13.2763C26.4682 13.2763 26.5081 13.2738 26.5491 13.2688C26.8342 13.2375 27.0882 13.0964 27.2674 12.8715C27.4454 12.6467 27.5264 12.3669 27.494 12.0808C26.9263 7.00932 23.0012 3.07328 17.9458 2.50991Z",
    fill: "#1D1D1D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7897 16.2155C18.776 21.2005 19.9072 15.4334 23.0821 18.606C26.1428 21.6659 27.902 22.279 24.024 26.1559C23.5383 26.5463 20.452 31.2428 9.60575 20.3996C-1.24185 9.555 3.45198 6.46556 3.84246 5.97994C7.72983 2.09231 8.33233 3.86173 11.3931 6.92166C14.568 10.0956 8.80332 11.2305 13.7897 16.2155Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e2a8f9e249fb985c5f5657591f2c8bb5.svg";
export { ForwardRef as ReactComponent };